<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.29688 0.125C1.21819 0.125 0.34375 0.999444 0.34375 2.07812V15.75C0.34375 17.4759 1.74286 18.875 3.46875 18.875H19.0938C17.3679 18.875 15.9688 17.4759 15.9688 15.75V2.07812C15.9688 0.999444 15.0943 0.125 14.0156 0.125H2.29688ZM10.5 7.15625C10.0685 7.15625 9.71875 7.50603 9.71875 7.9375C9.71875 8.36897 10.0685 8.71875 10.5 8.71875H12.0625C12.494 8.71875 12.8438 8.36897 12.8438 7.9375C12.8438 7.50603 12.494 7.15625 12.0625 7.15625H10.5ZM9.71875 4.8125C9.71875 4.38103 10.0685 4.03125 10.5 4.03125H12.0625C12.494 4.03125 12.8438 4.38103 12.8438 4.8125C12.8438 5.24397 12.494 5.59375 12.0625 5.59375H10.5C10.0685 5.59375 9.71875 5.24397 9.71875 4.8125ZM4.25 10.2812C3.81853 10.2812 3.46875 10.631 3.46875 11.0625C3.46875 11.494 3.81853 11.8438 4.25 11.8438H12.0625C12.494 11.8438 12.8438 11.494 12.8438 11.0625C12.8438 10.631 12.494 10.2812 12.0625 10.2812H4.25ZM3.46875 14.1875C3.46875 13.756 3.81853 13.4062 4.25 13.4062H12.0625C12.494 13.4062 12.8438 13.756 12.8438 14.1875C12.8438 14.619 12.494 14.9688 12.0625 14.9688H4.25C3.81853 14.9688 3.46875 14.619 3.46875 14.1875ZM4.25 4.03125C3.81853 4.03125 3.46875 4.38103 3.46875 4.8125V7.9375C3.46875 8.36897 3.81853 8.71875 4.25 8.71875H7.375C7.80647 8.71875 8.15625 8.36897 8.15625 7.9375V4.8125C8.15625 4.38103 7.80647 4.03125 7.375 4.03125H4.25Z"
                :fill="color" 
            />
            <path
                d="M17.5312 4.03125H19.4844C20.1316 4.03125 20.6562 4.55592 20.6562 5.20312V15.75C20.6562 16.6129 19.9567 17.3125 19.0938 17.3125C18.2308 17.3125 17.5312 16.6129 17.5312 15.75V4.03125Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNews',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>